import Login from 'containers/Admin/Login'

export default function LoginPage() {
  return (
    <Login />
  );
}
